import React, { useEffect, useMemo } from "react";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import validator from "validator";
import { Formik, Form, Field, ErrorMessage, useFormik } from "formik";
import * as Yup from "yup";
import TextErrorr from "../layout/TextError.jsx";
import AddressSearch, * as loqate from "react-loqate";
import { NavLink } from "react-router-dom";
import { Link } from "react-router-dom";
import ENUMS from "../../utils/ENUMS.js";
import axios from "axios";
import { Redirect } from "react-router-dom";
import { toast } from "react-toastify";
import { colors } from "@material-ui/core";
import CreateSelect from "../layout/CreateSelect.jsx";
import ApiService from "../api.js";
import { BASE_URL } from "../../config.json";
import { clearAllSpace } from "../../utils/helper.js";

const initialValues = {
  name: "",
  email: "",
  psw_1: "",
  psw_2: "",
  phone: "",
  website: "",
  address: "",
  address2: "",
  town: "",
  county: "",
  country: "",
  postcode: "",
  gname: "",
};

const MobileNoFormatter = ({ value, onChange }) => {
  const [isFocused, setIsFocused] = useState(false);

  const formattedVal = useMemo(() => {
    let _formattedVal = "";

    for (const char of value) {
      if (_formattedVal.length === 4 || _formattedVal.length === 8)
        _formattedVal += " ";

      _formattedVal += char;
    }

    return _formattedVal;
  }, [value]);

  return (
    <input
      className="form__input-md"
      onChange={onChange}
      // onFocus={() => setIsFocused(true)}
      // onBlur={() => setIsFocused(false)}
      type="text"
      placeholder="Phone Number"
      name="phone"
      value={value}
      // value={isFocused ? value : formattedVal}
    />
  );
};

const LoadInitValueFromLoacalStorage = () => {
  if (localStorage.getItem("Create-ClubDetail")) {
    let localStorageVal = JSON.parse(localStorage.getItem("Create-ClubDetail"));
    console.log(localStorageVal);
    // initialValues['name'] = localStorageVal.name
    // name
    initialValues["name"] = localStorageVal.name.trim();
    // email
    initialValues["email"] = localStorageVal.email;
    // psw_1
    initialValues["psw_1"] = localStorageVal.psw_1;
    // psw_2
    initialValues["psw_2"] = localStorageVal.psw_2;
    // phone
    initialValues["phone"] = localStorageVal.phone;
    // website
    initialValues["website"] = localStorageVal.website;
    // address
    initialValues["address"] = localStorageVal.address;
    //address2
    initialValues["address2"] = localStorageVal.address2;

    // town
    initialValues["town"] = localStorageVal.town;
    // county
    initialValues["county"] = localStorageVal.county;
    // country
    initialValues["country"] = localStorageVal.country;
    // postcode
    initialValues["postcode"] = localStorageVal.postcode;
    // gname
    initialValues["gname"] = localStorageVal.gname;
  }
};

LoadInitValueFromLoacalStorage();

const token = localStorage.getItem(ENUMS.AUTH);

const validationSchema = Yup.object({
  name: Yup.string().required("Required!"),
  email: Yup.string()
    .matches(
      /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,5}$/,
      "Invalid email address!"
    )
    .required("Required!"),
  psw_1: Yup.string().min(6).required("Required!"),
  psw_2: Yup.string().min(6).required("Required!"),
  phone: Yup.string().max(11).required("Required!"),
  website: Yup.string()
    .matches(
      /^(?:(ftp|http|https):\/\/)?(?:[\w-]+\.)+[a-z]{3,6}$/,
      "Enter correct url!"
    )
    .required("Please enter website"),
  address: Yup.string().required("Required!"),
  address2: Yup.string(),
  town: Yup.string().required("Required!"),
  country: Yup.string().required("Required!"),
  postcode: Yup.string().required("Required!"),
  gname: Yup.string().required("Required!"),
});

const validate = (values) => {
  const errors = {};
  if (!values.name) {
    errors.name = "Required";
  }
  if (!values.gname) {
    errors.gname = "Required";
  }
  if (!values.psw_1) {
    errors.psw_1 = "Required";
  } else if (!/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,32}$/.test(values.psw_1)) {
    errors.psw_1 =
      "Must Contain 8 Characters, 1 Uppercase, 1 Lowercase, 1 Number ";
  }
  if (!values.psw_2) {
    errors.psw_2 = "Required";
  } else if (values.psw_2 != values.psw_1) {
    errors.psw_2 = "Password Mismatch";
  }

  if (!values.phone) {
    errors.phone = "Required";
  }
  // else if (!/^\d{11}$/.test(values.phone)) {
  //     errors.phone = 'Invalid Number';
  // }
  else if (/^.{1,10}$/.test(values.phone)) {
    // else if (!(/^\d{16}$/).test(values.phone)) {
    errors.phone = "Invalid Number";
  }

  if (!values.email) {
    errors.email = "Required";
  } else if (
    !/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,5}$/.test(values.email)
  ) {
    errors.email = "Invalid email address";
  }

  if (!values.address) {
    errors.address = "Required";
  }

  if (!values.town) {
    errors.town = "Required";
  }

  if (!values.postcode) {
    errors.postcode = "Required";
  }

  if (!values.country) {
    errors.country = "Required";
  }

  if (!values.website) {
    errors.website = "Required";
  } else if (!validator.isURL(values.website)) {
    errors.website = "not valid";
  }

  if (!values.county) {
    errors.county = "Required";
  }

  return errors;
};
let List = [];

const ClubDetailForm = () => {
  const [initValll, SetinitValll] = useState(initialValues);
  const [passwordShown, setPasswordShown] = useState(false);
  const [passwordShownRepeat, setPasswordShownRepeat] = useState(false);
  const [loading, setLoading] = useState(true);
  const [Submit, SetSubmit] = useState(false);
  const [Data, getData] = useState([]);
  const [suggestionList, setSuggestionList] = useState([]);
  const [activeSuggestion, setActiveSuggestion] = useState(0);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [userInput, setUserInput] = useState();
  const [close, setClose] = useState(false);
  const [phone, setPhone] = useState("");
  const Get_List = () => {
    axios
      .get(`${BASE_URL}/club/get_unregistred_clubs/`)
      .then((res) => {
        List.push(res.data.data);
        getData(List[0]);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // Password toggle handler
  const togglePassword = () => {
    // When the handler is invoked
    // inverse the boolean state of passwordShown
    setPasswordShown(!passwordShown);
  };
  // Password toggle handler
  const togglePasswordRepeat = () => {
    // When the handler is invoked
    // inverse the boolean state of passwordShown
    setPasswordShownRepeat(!passwordShownRepeat);
  };

  const storeClubDetailsInLocalStorage = (values) =>
    localStorage.setItem("Create-ClubDetail", JSON.stringify(values));
  const checkClubDetailsRemoveLocalStorageItem = () =>
    localStorage.getItem("Create-ClubDetail") &&
    localStorage.removeItem("Create-ClubDetail");

  let history = useHistory();
  useEffect(() => {
    Get_List();
    LoadInitValueFromLoacalStorage();
    SetinitValll(initialValues);
    if (initialValues.gname !== "") {
      setLoading(false);
    }
  }, []);

  const formik = useFormik({
    initialValues: initValll,
    validate,
    onSubmit: async (values) => {
      // OnSubmit function to check and display formik error if email is already registered
      try {
        const res = await ApiService.checkEmailIsRegistered(values.email);
        try {
          const resClubVerify = await ApiService.checkClubRegistered(
            values.gname.trim()
          );
          storeClubDetailsInLocalStorage({ ...values });

          history.push("/golf-courses");
        } catch (err) {
          formik.errors.gname = "Golf Club is already registered with us";
          // formik.errors.gname = err.response.data.errMsg;
        }
      } catch (err) {
        formik.errors.email = err.response.data.errMsg;
      }
    },
    enableReinitialize: true,
  });

  const renderSuggestions = () =>
    suggestionList.map((item, index) => {
      const { Id, Description, Text } = item;

      let activeClass;
      if (index === activeSuggestion) {
        activeClass = "suggestion-active";
      }

      return (
        <li
          className={
            activeClass === "suggestion-active"
              ? "suggestion-active"
              : "suggestion"
          }
          onClick={(e, item) => {
            handleClick(e, Id, Description);
          }}
          key={Id}
        >
          <strong>
            <small>{`${Text}, ${Description}`}</small>
          </strong>
        </li>
      );
    });

  const handleKeyDown = (e) => {
    if (e.keyCode === 13) {
      setShowSuggestions(false);
      const selectedInput = suggestionList[activeSuggestion];
      setActiveSuggestion(0);
    } else if (e.keyCode === 38) {
      if (activeSuggestion === 0) {
        return;
      }
      setActiveSuggestion(activeSuggestion - 1);
    } else if (e.keyCode === 40) {
      if (activeSuggestion - 1 === suggestionList.length - 2) {
        return;
      }
      setActiveSuggestion(activeSuggestion + 1);
    }
  };

  const retrieveAddress = (Key, Id) => {
    var Field1Format = "";
    var url =
      "https://services.postcodeanywhere.co.uk/Capture/Interactive/Retrieve/v1.00/json3.ws";
    var params = "";
    params += "&Key=" + encodeURIComponent(Key);
    params += "&Id=" + encodeURIComponent(Id);
    params += "&Field1Format=" + encodeURIComponent(Field1Format);

    axios
      .post(url, params, {
        "Content-type": "application/x-www-form-urlencoded",
      })
      .then((res) => {
        const fll_address = res.data.Items[0];
        let address_line1, address_line2;
        address_line1 = `${fll_address.Label.split("\n").at(0)}`;
        address_line2 = fll_address.Line1;

        if (address_line1 === address_line2) {
          address_line1 = address_line1.split(" ").at(0);
          address_line2 = address_line2.split(" ").at(1);
        }

        SetinitValll({
          name: formik.values.name,
          gname: formik.values.gname.trim(),
          email: formik.values.email,
          psw_1: formik.values.psw_1,
          psw_2: formik.values.psw_2,
          phone: formik.values.phone,
          website: formik.values.website,
          address: address_line1,
          address2: address_line2,
          town: fll_address.City,
          county: fll_address.Province,
          postcode: fll_address.PostalCode,
          country: "UK",
        });
      })
      .catch((err) => console.log(err, "error"));
  };

  const handleChange = (e, secondFind) => {
    setShowSuggestions(true);
    //   SetinitValll({ ...initValll, address: e.target.value });
    setUserInput(userInput);
    setSuggestionList([]);
    let Text = e.target.value;
    let Container = "";
    if (secondFind !== undefined) {
      Container = secondFind;
      Text = formik.values.address;
    }
    const Key = "NH12-UF93-HD94-AB92",
      IsMiddleware = false,
      Origin = "",
      Countries = "GB",
      Limit = "10",
      Language = "en-us",
      url1 =
        "https://services.postcodeanywhere.co.uk/Capture/Interactive/Find/v1.10/json3.ws";
    var params = "";
    params += "&Key=" + encodeURIComponent(Key);
    params += "&Text=" + encodeURIComponent(Text);
    params += "&IsMiddleware=" + encodeURIComponent(IsMiddleware);
    params += "&Container=" + encodeURIComponent(Container);
    params += "&Origin=" + encodeURIComponent(Origin);
    params += "&Countries=" + encodeURIComponent(Countries);
    params += "&Limit=" + encodeURIComponent(Limit);
    params += "&Language=" + encodeURIComponent(Language);

    if (Text.length >= 3) {
      axios
        .post(url1, params, {
          "Content-type": "application/x-www-form-urlencoded",
        })
        .then(({ data }) => {
          const items = data.Items;
          setSuggestionList(items);

          // setSuggestionList(data.Items);
        })
        .catch((err) => console.log(err));
    }
  };

  const handleClick = async (e, Id, Description) => {
    const fullAddress = e.currentTarget.innerText.split(",");
    const Key = "NH12-UF93-HD94-AB92";

    if (Description.includes("Addresses")) {
      handleChange(e, Id);
    } else {
      retrieveAddress(Key, Id);
      setShowSuggestions(false);
      setSuggestionList([]);
      setActiveSuggestion(0);
    }

    // retrieveAddress(Key, Id);
  };
  console.log(formik);

  const onPhoneCHange = (input) => {
    // debugger
    // setPhone(input.target.value)
    if (input.target.value.length < 15) {
      if (input.target.value.length === 2) {
        // setPhone(`${input.target.value} `)
        var target = input.target,
          position = target.selectionEnd,
          length = target.value.length;
        target.value = target.value
          .replace(/[^\dA-Z]/g, "")
          .replace(/(.{4})/g, "$1 ")
          .trim();
        target.selectionEnd = position +=
          target.value.charAt(position - 1) === " " &&
          target.value.charAt(length - 1) === " " &&
          length !== target.value.length
            ? 1
            : 0;

        formik.setFieldValue("phone", input.target.value);
        // formik.setFieldValue('phone',`${input.target.value}9`)
      }
      if (input.target.value.length === 7) {
        // setPhone(`${input.target.value} `)
        formik.setFieldValue("phone", `${input.target.value} `);
      }
      // setPhone(input.target.value)
    }
  };
  // console.log(phone)
  const handlePhone = (e) => {
    console.log(e.target.value);
    const val = clearAllSpace(e.target.value || "");
    return val;
  };
  return (
    // console.log(Data, "NEW"),
    <>
      <div className="cdetail">
        <div className="cdetail__wrap">
          <Formik
            initialValues={initValll}
            validationSchema={validationSchema}
            enableReinitialize={true}
          >
            <form onSubmit={formik.handleSubmit} className="cdetail__box">
              <div className="cdetail__box__left">
                <div className="errors__container">
                  <input
                    className="form__input-md"
                    type="text"
                    placeholder="Contact NAME*"
                    name="name"
                    onChange={formik.handleChange}
                    value={formik.values.name}
                  />
                  {formik.touched["name"] &&
                    (formik.errors.name ? (
                      <div className="errors" style={{ color: "red" }}>
                        * {formik.errors.name}
                      </div>
                    ) : null)}
                </div>

                <div className="errors__container">
                  <Field
                    name="gname"
                    options={useMemo(
                      () =>
                        Data && Data.length > 0
                          ? Data.map((user) => ({
                              id: user.id,
                              label: user.club_name,
                              value: user.club_name,
                            }))
                          : [],
                      [Data]
                    )}
                    component={CreateSelect}
                    placeholder="Golf Club Name"
                    loading={loading}
                    formik={formik}
                    initialValues={initialValues}
                  />
                  {formik.touched.gname && formik.errors.gname && (
                    <div className="errors" style={{ color: "red" }}>
                      * {formik.errors.gname}
                    </div>
                  )}
                </div>

                <div className="errors__container">
                  <input
                    className="form__input-md"
                    type="text"
                    placeholder="email address*"
                    name="email"
                    onChange={formik.handleChange}
                    value={formik.values.email.toLowerCase()}
                  />
                  {formik.touched["email"] &&
                    (formik.errors.email ? (
                      <div className="errors" style={{ color: "red" }}>
                        * {formik.errors.email}
                      </div>
                    ) : null)}
                </div>

                <div className="errors__container password">
                  <input
                    className="form__input-md"
                    type={passwordShown ? "text" : "password"}
                    placeholder="Create a Password*"
                    name="psw_1"
                    onChange={formik.handleChange}
                    value={formik.values.psw_1}
                  />
                  <span onClick={togglePassword}>
                    {passwordShown === true ? (
                      <img
                        src={
                          require("../../assets/images/password_img/show.svg")
                            .default
                        }
                        alt=""
                      />
                    ) : (
                      <img
                        src={
                          require("../../assets/images/password_img/hide.svg")
                            .default
                        }
                        alt=""
                      />
                    )}
                  </span>
                  {formik.touched["psw_1"] &&
                    (formik.errors.psw_1 ? (
                      <div className="errors" style={{ color: "red" }}>
                        * {formik.errors.psw_1}
                      </div>
                    ) : null)}
                </div>
                <div className="errors__container password">
                  <input
                    className="form__input-md"
                    type={passwordShownRepeat ? "text" : "password"}
                    placeholder="Confirm Password*"
                    name="psw_2"
                    onChange={formik.handleChange}
                    value={formik.values.psw_2}
                  />
                  <span onClick={togglePasswordRepeat}>
                    {passwordShownRepeat === true ? (
                      <img
                        src={
                          require("../../assets/images/password_img/show.svg")
                            .default
                        }
                        alt=""
                      />
                    ) : (
                      <img
                        src={
                          require("../../assets/images/password_img/hide.svg")
                            .default
                        }
                        alt=""
                      />
                    )}
                  </span>

                  {formik.touched["psw_2"] &&
                    (formik.errors.psw_2 ? (
                      <div className="errors" style={{ color: "red" }}>
                        * {formik.errors.psw_2}
                      </div>
                    ) : null)}
                </div>
                <div className="errors__container">
                  {/*<input className="form__input-md" type="text" placeholder="Phone Number*"*/}
                  {/*       name="phone"*/}
                  {/*       onChange={formik.handleChange}*/}
                  {/*       value={formik.values.phone}*/}
                  {/*/>*/}
                  {/*<MobileNoFormatter*/}
                  {/*    onChange={formik.handleChange}*/}
                  {/*    value={formik.values.phone}*/}
                  {/*/>*/}
                  <input
                    className="form__input-md"
                    type="text"
                    placeholder="Phone Number"
                    name="phone"
                    // onChange={formik.handleChange}
                    value={formik.values.phone}
                    onChange={(event) =>
                      formik.setFieldValue(
                        "phone",
                        clearAllSpace(event.target.value)
                      )
                    }
                  />
                  {formik.touched["phone"] &&
                    (formik.errors.phone ? (
                      <div className="errors" style={{ color: "red" }}>
                        * {formik.errors.phone}
                      </div>
                    ) : null)}
                </div>
                <div className="errors__container">
                  <input
                    className="form__input-md"
                    type="text"
                    placeholder="Website URL"
                    name="website"
                    onChange={formik.handleChange}
                    value={formik.values.website}
                  />
                  {formik.touched["website"] &&
                    (formik.errors.website ? (
                      <div className="errors" style={{ color: "red" }}>
                        * {formik.errors.website}
                      </div>
                    ) : null)}
                </div>
              </div>

              <div className="cdetail__box__right">
                <div className="errors__container">
                  <div className="address__suggestion">
                    <input
                      className="form__input-md"
                      type="text"
                      id="address"
                      placeholder="Start to type your address…"
                      onKeyDown={handleKeyDown}
                      name="address"
                      onChange={(e) => {
                        formik.handleChange(e);
                        handleChange(e);
                      }}
                      autocomplete="none"
                      value={formik.values.address}
                    />
                    <ul className="suggestion__items">
                      {suggestionList !== [] &&
                        showSuggestions &&
                        renderSuggestions()}
                      {suggestionList === [] && (
                        <li className="suggestion">
                          <strong>
                            <small>There are no results</small>
                          </strong>
                        </li>
                      )}
                    </ul>
                    {formik.touched["address"] &&
                      (formik.errors.address ? (
                        <div className="errors" style={{ color: "red" }}>
                          * {formik.errors.address}
                        </div>
                      ) : null)}
                  </div>
                </div>

                <input
                  className="form__input-md"
                  type="text"
                  placeholder="Address Line 2"
                  name="address2"
                  value={formik.values.address2}
                  onChange={formik.handleChange}
                />

                <div className="errors__container">
                  <input
                    className="form__input-md"
                    type="text"
                    placeholder="Town"
                    name="town"
                    onChange={formik.handleChange}
                    value={formik.values.town}
                  />
                  {formik.touched["town"] &&
                    (formik.errors.town ? (
                      <div className="errors" style={{ color: "red" }}>
                        * {formik.errors.town}
                      </div>
                    ) : null)}
                </div>
                <div className="errors__container">
                  <input
                    className="form__input-md"
                    type="text"
                    id="county"
                    placeholder="County*"
                    name="county"
                    onChange={formik.handleChange}
                    value={formik.values.county}
                  />
                  {formik.touched["county"] &&
                    (formik.errors.county ? (
                      <div className="errors" style={{ color: "red" }}>
                        * {formik.errors.county}
                      </div>
                    ) : null)}
                </div>

                <div className="errors__container">
                  <Field
                    name="country"
                    options={[
                      { id: 1, label: "USA", value: "USA" },
                      { id: 2, label: "UK", value: "UK" },
                      { id: 3, label: "India", value: "India" },
                    ]}
                    component={CreateSelect}
                    formik={formik}
                    placeholder="Country*"
                    loading={false}
                    initialValues={initialValues}
                    searchable={false}
                  />

                  {formik.touched["country"] &&
                    (formik.errors.country ? (
                      <div className="errors" style={{ color: "red" }}>
                        * {formik.errors.country}
                      </div>
                    ) : null)}
                </div>
                {/* <div className="custom-select-wrapper"> */}
                {/* <div>



                                            <div>
                                                <select className="form__input-md" onChange={formik.handleChange}
                                                        value={formik.values.country}
                                                        placeholder="country" name="country" id="cars" style={{
                                                    padding: '0rem 5rem'}}>
                                                    <option value="" disabled selected>COUNTRY *</option>
                                                    <option value="India">India</option>
                                                    <option>USA</option>
                                                    <option>UK</option>

                                                </select>
                                                {formik.touched['country'] && (formik.errors.country ?
                                                    <div style={{color: 'red'}}>* {formik.errors.country}</div> : null)}

                                            </div>
                                        </div> */}
                {/* </div> */}
                <div className="errors__container">
                  <input
                    className="form__input-md"
                    type="text"
                    placeholder="Postcode*"
                    name="postcode"
                    id="postcode"
                    onChange={formik.handleChange}
                    value={formik.values.postcode}
                  />
                  {formik.touched["postcode"] &&
                    (formik.errors.postcode ? (
                      <div className="errors" style={{ color: "red" }}>
                        * {formik.errors.postcode}
                      </div>
                    ) : null)}
                </div>
                <div className="cdetail__box__right-links">
                  <button type="submit" className="res-btn-primary">
                    NEXT
                  </button>
                </div>
              </div>
            </form>
          </Formik>
        </div>
      </div>
    </>
  );
};

export default ClubDetailForm;
